import { Box, Button, TextButton } from '@wix/design-system';
import { EditSmall as EditSmallIcon } from '@wix/wix-ui-icons-common';
import React from 'react';
import { useTranslation } from '../../hooks';
export const ApprovalRequest = _ref => {
  let {
    entry,
    onApprove,
    onReject,
    onEditApproval
  } = _ref;
  const {
    t
  } = useTranslation();
  const handleApprove = () => {
    onApprove(entry);
  };
  const handleReject = () => {
    onReject(entry);
  };
  const handleEditApproval = () => {
    onEditApproval == null || onEditApproval(entry);
  };
  const showEditButton = !!onEditApproval && entry.showApprovalEdit;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP2",
    align: "left"
  }, showEditButton && /*#__PURE__*/React.createElement(TextButton, {
    size: "tiny",
    weight: "normal",
    prefixIcon: /*#__PURE__*/React.createElement(EditSmallIcon, null),
    onClick: handleEditApproval
  }, t('approval.edit.button')), /*#__PURE__*/React.createElement(Box, {
    gap: "SP2"
  }, /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    onClick: handleApprove
  }, t('approval.approve.button')), /*#__PURE__*/React.createElement(Button, {
    size: "tiny",
    skin: "destructive",
    priority: "secondary",
    onClick: handleReject
  }, t('approval.reject.button'))));
};
//# sourceMappingURL=ApprovalRequest.js.map